import { StockType } from "models/Stock";
import api from "Services/API";
import { ListResponseType } from "Services/Share.props";

export enum ExcelType {
    "food" = 1,
    "good" = 2,
    "dryGood" = 3,
}

export const getStocks = (params?: Record<string, number | undefined>) => {
    return api.get<ListResponseType<StockType>>("/admin/stock", {
        params,
    });
};

export const submitStocks = (body: any) => {
    return api.post("/admin/stock", body);
};
export const barcodeData = () => {
    return api.get("/admin/barcode/food-search/hub");
};

export const getStockReasons = (params: any) => {
    return api.get(`/admin/stock/reasons`, { params });
};

export const getFoodsList = (params: any) => {
    return api.get(`/admin/food`, { params });
};
export const getGoodsDataPerVendor = (params: any) => {
    return api.get(`/admin/consumable-good/list`, { params });
};
export const getBranchesDataPerVendor = (params: any) => {
    return api.get(`/admin/branch`, { params });
};
export const getB2bOrders = ({ branchId, date }: any) => {
    return api.get(
        `/admin/branch/b2borders?branch_id=${branchId}&shift=1&date=${date}`
    );
};
export const uploadFile = (body: any) => {
    return api.post(`/admin/upload/file`, body);
};

export const uploadReceivingFile = (body: any) => {
    return api.put(`/admin/receiving/file`, body);
};

export const getSOPTags = (body: any) => {
    return api.get(`/sop-receiving-tags`);
};

export const downloadStockExcelTemplate = (params: {
    type: ExcelType;
    branchId: number;
}) => {
    return api.get(`/admin/branch/${params.branchId}/stock-change-template`, {
        params: { type: params.type },
    });
};

export const uploadStockExcel = ({
    body,
    id,
    type,
}: {
    body: any;
    id: number;
    type: ExcelType;
}) => {
    return api.post(
        `/admin/branch/${id}/upload/stock-change-excel?type=${type}`,
        body
    );
};
